export default __webpack_public_path__ + "static/waermerueckgewinnung-frequenzumrichter_boge-kompressoren-9410c29088b6f04a5c9fed4ea8d40ed9.jpeg";